import type {
	ClientPropertyItemResponseDTO,
	PortfolioListItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { PORTFOLIO_CONTRACT_STATE } from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import { availablePortfolioCategories } from "web_myplann/Portfolio/Helpers/availablePortfolioCategories";
import type { AvailableCategoriesByContractState } from "web_myplann/Portfolio/Types/AvailableCategoriesByContractState";

export const availableCategoriesByContractState = (
	portfolioItems: PortfolioListItemResponseDTO[],
	propertyItems: ClientPropertyItemResponseDTO[],
): AvailableCategoriesByContractState => ({
	[PORTFOLIO_CONTRACT_STATE.all]: availablePortfolioCategories(
		portfolioItems.filter((item) => !item.archived),
		propertyItems.filter((item) => !item.archived),
	),
	[PORTFOLIO_CONTRACT_STATE.archived]: availablePortfolioCategories(
		portfolioItems.filter((item) => item.archived),
		propertyItems.filter((item) => item.archived),
	),
});
